exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-fields {\n    padding: 11px 15px;\n    border: 0;\n    background: #fd7e14;\n    color: #fff;\n    /* font-size: 17px; */\n    line-height: 17px;\n    border-radius: 8px;\n    cursor: pointer;\n}\n.remove-fields {\n    padding: 11px 15px;\n    border: 0;\n    background: #fd7e14;\n    color: #fff;\n    line-height: 17px;\n    border-radius: 8px;\n    float: right;\n    margin-left: 10px;\n    cursor: pointer;\n}\n.visibility-hidden {\n    visibility: hidden;\n}\n.download-button {\n    font-size: 12px !important;\n}\n", ""]);

// exports
